import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

function DeliveryTruck(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 31.057 14.876" fontSize={'inherit'} {...props}>
      <g
        id="Groupe_246"
        data-name="Groupe 246"
        transform="translate(-260.75 -173.394)"
      >
        <g
          id="Groupe_71"
          data-name="Groupe 71"
          transform="translate(271.659 173.394)"
        >
          <g
            id="Groupe_53"
            data-name="Groupe 53"
            transform="translate(0 0)"
            clipPath="url(#clip-path)"
          >
            <path
              id="Tracé_44"
              data-name="Tracé 44"
              d="M4.453,14.876a2.685,2.685,0,0,1-1.941-.793,2.614,2.614,0,0,1-.825-1.917H1.555a1.677,1.677,0,0,1-1.131-.533A1.691,1.691,0,0,1,0,10.453V1.713A1.646,1.646,0,0,1,.516.52,1.637,1.637,0,0,1,1.713,0h11.24A1.44,1.44,0,0,1,14.1.532a2.442,2.442,0,0,1,.561,1.181V3.749h2a.958.958,0,0,1,.4.083.676.676,0,0,1,.292.249l2.637,3.472a1.292,1.292,0,0,1,.113.24.861.861,0,0,1,.047.289v3.234a.83.83,0,0,1-.851.85h-.882a2.611,2.611,0,0,1-.823,1.923,2.69,2.69,0,0,1-1.939.787,2.737,2.737,0,0,1-2.748-2.71h-5.7a2.613,2.613,0,0,1-.822,1.923,2.682,2.682,0,0,1-1.933.787m0-1.6a1.124,1.124,0,0,0,.828-.348,1.171,1.171,0,0,0,0-1.659,1.163,1.163,0,0,0-1.66,0A1.178,1.178,0,0,0,4.45,13.28M1.713,1.713v8.739h.544a3.022,3.022,0,0,1,.969-.842,2.491,2.491,0,0,1,1.2-.3,2.438,2.438,0,0,1,1.211.316,3.4,3.4,0,0,1,.979.826h6.335V1.713ZM15.652,13.28a1.124,1.124,0,0,0,.828-.348,1.163,1.163,0,1,0-.828.348m-.986-4.691H18.6L16.246,5.467h-1.58Z"
              transform="translate(0 0)"
              fill="#d8006b"
            />
          </g>
        </g>
        <path
          id="Ligne_8"
          data-name="Ligne 8"
          d="M5.8.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H5.8a.75.75,0,0,1,.75.75A.75.75,0,0,1,5.8.75Z"
          transform="translate(263.822 182.733)"
          fill="#d8006b"
        />
        <path
          id="Ligne_10"
          data-name="Ligne 10"
          d="M5.8.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H5.8a.75.75,0,0,1,.75.75A.75.75,0,0,1,5.8.75Z"
          transform="translate(263.822 178.09)"
          fill="#d8006b"
        />
        <path
          id="Ligne_9"
          data-name="Ligne 9"
          d="M5.8.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H5.8a.75.75,0,0,1,.75.75A.75.75,0,0,1,5.8.75Z"
          transform="translate(261.5 180.412)"
          fill="#d8006b"
        />
      </g>
    </SvgIcon>
  );
}

export default DeliveryTruck;
